export default __webpack_public_path__ + "static/media/failed.42bb3aad.svg";